import request from "../../../../utils/api";

const users = "users";

export const getUsers = params => request(users, { params })
export const postUser = body => request(`${users}`, { method: 'post', body });
export const putUser = body => request(`${users}/${body.user.id}`, { method: 'put', body });
export const deleteUser = body => request(`${users}/${body}`, { method: 'delete' });